// built-in imports
import { useState } from "react";

// internal imports
import { Wrapper, Button } from "./tab.styles";

const Tab = ({ activeTab, handleTab }) => {
  return (
    <Wrapper>
      <Button
        onClick={() => handleTab("hands-on")}
        isactive={activeTab === "hands-on" ? "true" : "false"}
      >
        Hands-on
      </Button>
      <Button
        onClick={() => handleTab("collaborated")}
        isactive={activeTab === "collaborated" ? "true" : "false"}
      >
        Collaborative
      </Button>
    </Wrapper>
  );
};
export default Tab;
